import React from "react";
import _join from "lodash/join";
import { VocabularyUri } from "./VocabularyUri";
import { VocabularyItem } from "./VocabularyItem";

export const RORInstitutionResultListItem = ({
  result,
  handleSelect = () => {},
  selected,
}) => {

  const { relatedURI, title, props } = result;

  const uriLinks = VocabularyUri(relatedURI)

  const displayProps = (({ city, country }) => ({ city, country}))(props);
  const propValues = _join(Object.values(displayProps), ", ");

  const onSelect = (result) => {
    handleSelect(result, selected);
  };

  return VocabularyItem({ onSelect, result, selected, title, uriLinks, propValues });
};
